import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from '../../../contexts/auth';
import { LegalDocuments } from '../legalDocuments/legalDocuments.component';

export const Profile = () => {
  const { t } = useTranslation();
  const { currentUser, currentUserLoading } = useAuthContext();

  if (currentUserLoading || !currentUser) {
    return (
      <Box sx={{ display: 'flex' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h6">{t("First name and last name")}: {currentUser.first_name} {currentUser.last_name}</Typography>
      <Typography variant="body1">{t("Email address")}: {currentUser.email}</Typography>
      <LegalDocuments />
    </Box>
  );
};
